module.exports = __webpack_public_path__ + "img/UserSysteamInterests.015e8a6d.svg";